import { Action } from '@ngrx/store';
import { Observable } from 'rxjs';
import { vshcDialogOpen, vshcDialogClose } from './dialog.action';
import { ofType } from '@ngrx/effects';
import { filter } from 'rxjs/operators';

export const onVshcDialogOpen = (k: string) => {
  return (source$: Observable<Action>) => source$.pipe(
    ofType(vshcDialogOpen),
    filter(({ key }) => key === k)
  );
};

export const onVshcDialogClose = (k: string) => {
  return (source$: Observable<Action>) => source$.pipe(
    ofType(vshcDialogClose),
    filter(({ key }) => key === k)
  );
};
